<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title">
            <template v-slot:actions>
                <rkm-button @click="$refs.List.refresh()">
                    Atualizar lista
                </rkm-button>

                <rkm-button
                    v-if="authorize('cadastro-waba-template-store')"
                    @click="showImport = true"
                    color="primary"
                    outline
                >
                    Sincronizar com o Engine
                </rkm-button>

            </template>
        </rkm-content-header>

        <rkm-content-body>
            <rkm-container>
                <List @select="openTemplateDetails" ref="List" />
            </rkm-container>
        </rkm-content-body>

        <rkm-modal
            :buttons="['cancel']"
            :loading="detailsLoading"
            :visible="detailsVisible"
            @close="closeTemplateDetails"
            extra-large
            title="Detalhes do template"
        >
            <rkm-overlay :show="detailsLoading">
                <template v-if="selectedTemplate">
                    <rkm-row>
                        <rkm-col cols="5">
                            <strong>Nome</strong>
                            <div>{{ selectedTemplate.name }}</div>
                        </rkm-col>

                        <rkm-col cols="3">
                            <strong>Idioma</strong>
                            <div>{{ selectedTemplate.language }}</div>
                        </rkm-col>

                        <rkm-col cols="4">
                            <strong>Status</strong>
                            <div :class="selectedTemplate.statusDetails.class">
                                {{ selectedTemplate.statusDetails.label }}
                            </div>
                        </rkm-col>
                    </rkm-row>

                    <hr>

                    <h5>Conteúdo</h5>
                    <div class="template-content border rounded bg-light p-3 mb-4">
                        {{ selectedTemplate.content }}
                    </div>

                    <h5>Parâmetros</h5>
                    <rkm-table
                        v-if="selectedTemplate.parameters.length"
                        :fields="parameterFields"
                        :items="selectedTemplate.parameters"
                        hide-filters
                        hide-pagination
                    />
                    <p v-else class="text-muted">Este template não possui parâmetros.</p>

                    <h5 class="mt-4">Botões</h5>
                    <rkm-table
                        v-if="selectedTemplate.buttons.length"
                        :fields="buttonFields"
                        :items="selectedTemplate.buttons"
                        hide-filters
                        hide-pagination
                    />
                    <p v-else class="text-muted mb-0">Este template não possui botões.</p>
                </template>
            </rkm-overlay>
        </rkm-modal>

        <rkm-modal
            :buttons="['cancel']"
            :loading="requesting"
            :visible="showImport"
            @close="closeImport"
            title="Sincronizar template com o Engine"
        >
            <rkm-form ref="ImportForm">
                <rkm-form-input
                    :validations="{required: true, regex: /^[a-z0-9_]+$/}"
                    label="Nome do template"
                    placeholder="Ex.: consulta_agendada"
                    v-model="templateName"
                />
            </rkm-form>

            <p class="text-muted mb-0">
                O Engine será consultado por HTTP e o template será incluído ou atualizado imediatamente.
            </p>

            <template v-slot:footer>
                <rkm-button
                    :disabled="requesting"
                    @click="syncTemplate"
                    color="primary"
                >
                    Sincronizar
                </rkm-button>
            </template>
        </rkm-modal>
    </rkm-content>
</template>

<script>
import List from '@/components/cadastro/waba-template/List'
import {authorization, error, notification} from '@/mixins'

export default {
    components: {List},
    data: () => ({
        buttonFields: [
            {key: 'index', label: 'Índice', class: 'text-center'},
            {key: 'action', label: 'Ação'},
        ],
        detailsLoading: false,
        detailsVisible: false,
        parameterFields: [
            {key: 'position', label: 'Posição', class: 'text-center'},
            {key: 'key', label: 'Chave'},
            {key: 'type', label: 'Tipo'},
        ],
        requesting: false,
        selectedTemplate: null,
        showImport: false,
        templateName: null,
    }),
    inject: ['repositories'],
    methods: {
        closeTemplateDetails() {
            if (!this.detailsLoading) {
                this.detailsVisible = false
                this.selectedTemplate = null
            }
        },
        closeImport() {
            if (!this.requesting) {
                this.showImport = false
                this.templateName = null
            }
        },
        openTemplateDetails(summary) {
            this.detailsVisible = true
            this.detailsLoading = true
            this.selectedTemplate = null

            this.repositories.cadastro.wabaTemplate.showByName(summary.name)
                .then(({data}) => {
                    this.selectedTemplate = {
                        ...data,
                        status: summary.status,
                        statusDetails: summary.statusDetails,
                    }
                })
                .catch(error => {
                    this.detailsVisible = false
                    this.handleError(error)
                })
                .finally(() => this.detailsLoading = false)
        },
        syncTemplate() {
            this.$refs.ImportForm.validate().then(validated => {
                if (!validated) {
                    return
                }

                this.requesting = true
                this.repositories.cadastro.wabaTemplate.syncFromEngine(this.templateName)
                    .then(() => {
                        this.showSuccessNotification(
                            'Template sincronizado',
                            `O template ${this.templateName} foi importado do Engine.`
                        )
                        this.$refs.List.refresh()
                        this.showImport = false
                        this.templateName = null
                    })
                    .catch(this.handleError)
                    .finally(() => this.requesting = false)
            })
        },
    },
    mixins: [authorization, error, notification],
}
</script>

<style scoped>
.template-content {
    min-height: 5rem;
    white-space: pre-wrap;
}
</style>
